import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_13: FaireProductEntity = {
  token: "catalog_prod_prod-13",
  type: "product",
  name: "Reversible Pillow - Happy Birthday - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 84.38,
  msrpDollars: 210.95,
  sku: "CO0013",
  caseSize: 6,
  material: "Wood",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 264,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_candles-holders"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
